import React, { useEffect, useState } from "react";
import "../tabs/css/BlogPage.css";

export default function MainPage() {
  const [news, setNews] = useState([]);
  const [techTopics, setTechTopics] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Fetch News of the Week
    fetch("https://website-backend-production-2163.up.railway.app/api/news")
      .then((res) => res.json())
      .then((data) => setNews(data))
      .catch((err) => console.error("Error fetching news:", err));

    // Fetch Tech Topics
    fetch("https://website-backend-production-2163.up.railway.app/api/tech-topics")
      .then((res) => res.json())
      .then((data) => setTechTopics(data))
      .catch((err) => console.error("Error fetching tech topics:", err));
  }, []);

  return (
    <div className="main-page-container">
      {/* Navbar */}
      <div className="main-page-navbar">
        <div className="main-page-title"><a style={{textDecoration:"none", color: "#333"}} href="/">FN Studio</a></div>
        {/* <img className="keycapPic" src="Designer3DFNKeycap.png" alt="FN Keycap" /> */}
        <div className="main-page-links">
          <a href="/">Home</a>
          <a href="/hub">Hub</a>
          <a href="/services">Services</a>
          <a href="/projects">Projects</a>
          <a href="/about-me">Contact</a>
        </div>

        {/* Hamburger Icon */}
        <button
          className="hamburger"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          ☰
        </button>
      </div>
      {/* Mobile Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <a href="/">Home</a>
          <a href="/hub">Hub</a>
          <a href="/services">Services</a>
          <a href="/projects">Projects</a>
          <a href="/about-me">Contact</a>
        </div>
      )}
      <div className="main-page-content-wrapper">
        {/* News Section */}
        <section className="main-page-news-section">
          <h2 className="text-3xl font-semibold mb-4">News of the Week</h2>
          <div className="main-page-news-cards-container">
            {news.slice(-4).reverse().map((item) => (
              <div key={item._id} className="main-page-news-card">
                <div className="news-card-header">
                  <h3 className="text-xl font-bold mb-2" style={{ margin: 0 }}>{item.title}</h3>
                  <p className="news-date" style={{ margin: 0, fontSize: "0.9rem", color: "#666" }}>
                    {new Date(item.date).toLocaleDateString()}
                  </p>
                </div>
                <p>{item.description}</p>
                {item.url && (
                  <a href={item.url} target="_blank" rel="noopener noreferrer">🌐 Go to source</a>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Tech Topics Section */}
        <section className="main-page-tech-section">
          <h2 className="text-2xl font-semibold mb-6 border-b pb-2">Tech News & Things To Explore</h2>
          <div className="tech-cards-grid">
            {techTopics.slice(-3).reverse().map((topic) => (
              <div key={topic._id} className="tech-card">
                {topic.img && (
                  <img
                    src={topic.img}
                    alt={topic.title}
                    className="tech-card-image"
                  />
                )}

                {topic.category && (
                  <p className="tech-card-category">{topic.category}</p>
                )}

                <h3 className="tech-card-title">
                  {topic.url ? (
                    <a href={topic.url} target="_blank" rel="noopener noreferrer">
                      {topic.title}
                    </a>
                  ) : (
                    topic.title
                  )}
                </h3>

                {topic.description && (
                  <div className="tech-card-meta">
                    <span className="description-tech">
                      {topic.description.length > 100
                        ? topic.description.slice(0, 150) + "..."
                        : topic.description}
                    </span>

                  </div>
                )}
              </div>
            ))}
          </div>
        </section>


      </div>



      {/* Footer */}
      <footer className="main-page-footer">
        © {new Date().getFullYear()} fn-studio. All rights reserved.
      </footer>
    </div>
  );
}